import { useEffect } from 'react';
import { Card, Box } from '@nimbus-ds/components';
import { InitialScreen } from '@nimbus-ds/patterns';
import { DomainOrderResponseDto } from '@tiendanube/common';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';
import initialScreenImage from './img/pago-en-processo.png';
import { trackingNuvemDomainsPaymentProcess } from '../../../../tracking';

interface PendingOrderCardProps {
  order: DomainOrderResponseDto;
}

export function PendingOrderCard({
  order: _order,
}: Readonly<PendingOrderCardProps>) {
  const t = useTranslationConfigurations('domains.orderDetails.pendingOrder');

  useEffect(() => {
    trackingNuvemDomainsPaymentProcess();
  }, []);

  return (
    <Card>
      <Box padding="8">
        <InitialScreen paddingTop="none">
          <InitialScreen.Hero
            title={t('title')}
            description={t('description')}
            image={
              <img src={initialScreenImage} width="100%" alt={t('imageAlt')} />
            }
          />
        </InitialScreen>
      </Box>
    </Card>
  );
}
